import { Button, Flex, Menu } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapChart } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useState } from 'react';
import { InfoBox } from '@dealstack/frontend/shared/components/InfoBox/InfoBox';

export const CapInvalidTransactionsWarning = ({
	showInvalidTransactions,
}: {
	showInvalidTransactions: () => void;
}) => {
	const tCapChart = useTranslationCapChart();
	const [opened, setOpened] = useState(false);

	return (
		<Menu
			width={388}
			opened={opened}
			onClose={() => setOpened(false)}
			shadow="md"
			position="bottom-end"
		>
			<Menu.Target>
				<Button
					variant="subtle"
					color="red"
					onClick={() => setOpened(!opened)}
					sx={(theme) => ({
						border: '1px solid',
						borderColor: theme.colors.red[0],
						'&[data-expanded="true"]': {
							backgroundColor: theme.colors.red[0],
						},
					})}
				>
					<Icon variant="warning" size="vlg" />
				</Button>
			</Menu.Target>

			<Menu.Dropdown
				p="0"
				style={{
					border: 'none',
					borderRadius: '0.5rem',
					boxShadow: '0px 16px 32px 0px #DCDFE0',
				}}
			>
				<InfoBox
					title={tCapChart('warnings.incomplete_transactions.title')}
					description={tCapChart('warnings.incomplete_transactions.info')}
					direction="column"
					rippleColor="red"
					iconVariant="warning"
				>
					<Flex justify="space-between">
						<Button variant="subtle" onClick={showInvalidTransactions}>
							{tCapChart('warnings.incomplete_transactions.buttons.show_me')}
						</Button>
						<Button
							variant="subtle"
							color="gray"
							c="dark.8"
							onClick={() => setOpened(false)}
						>
							{tCapChart('warnings.incomplete_transactions.buttons.hide')}
						</Button>
					</Flex>
				</InfoBox>
			</Menu.Dropdown>
		</Menu>
	);
};
